import styles from "./MyCharts.module.css";
import React from "react";

const MyLegend = (props) => {
    const { payload } = props;

    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <ul className={styles.legendUl} style={{ listStyle: 'none', margin: '0 auto', padding: 0 }}>
                {
                    payload.map((entry, index) => (
                        <li key={`item-${index}`} style={{ color: entry.payload.fillBorder || entry.payload.fill }}>
                            <span className={styles.legendLabel}>{entry.value}</span>
                        </li>
                    ))
                }
            </ul>
        </div>
    );
};

export default MyLegend;